<template>
  <a-spin :spinning="loading">
    <a-descriptions :column="3" style="margin-bottom: -15px">
      <a-descriptions-item :label="$t('business.label.orderNo')">
        <span class="normalFont">{{order.no}}</span>
      </a-descriptions-item>
      <a-descriptions-item :label="$t('business.label.countingType')">
        <span class="normalFont">{{order.countingType !== null && order.countingType !== undefined ? countingTypes.find(item => item.ordinal === order.countingType).name : null}}</span>
      </a-descriptions-item>
      <a-descriptions-item :label="$t('business.label.invoiceTime')">
        <span class="normalFont">{{order.invoiceTime}}</span>
      </a-descriptions-item>
      <a-descriptions-item :label="$t('business.label.storer')">
        <span class="normalFont">{{order.storer.name}}</span>
      </a-descriptions-item>
      <a-descriptions-item :label="$t('business.label.warehouse')">
        <span class="normalFont">{{order.warehouse.name}}</span>
      </a-descriptions-item>
      <a-descriptions-item :label="$t('business.label.operator')">
        <span class="normalFont">{{order.operator}}</span>
      </a-descriptions-item>
    </a-descriptions>
    <vxe-table
      border
      stripe
      round
      show-overflow
      show-header-overflow
      :export-config="{}"
      ref="table"
      align="center"
      :data="details"
      :loading="loading"
      :keyboard-config="{isArrow: true}"
      :scroll-x="{enabled: true}"
      :height="scrollY"
      size="mini"
      :row-config="{isCurrent: true, isHover: true}"
      :column-config="{resizable: true}"
      style="margin-top: 2px">
      <vxe-column fixed="left" type="seq" width="40"/>
      <vxe-column field="item.no" title="business.label.itemNo" width="80"/>
      <vxe-column field="item.name" title="business.label.itemName"/>
      <vxe-column field="pack.specification" title="business.label.specification"/>
      <vxe-column field="pack.factor" title="business.label.factor" width="60"/>
      <vxe-column field="lot.no" title="business.label.lot"/>
      <vxe-column field="lot.manufacturer" title="business.label.manufacturer"/>
      <vxe-column field="lot.producingArea" title="business.label.producingArea"/>
      <vxe-column field="container.no" title="business.label.containerNo" width="90"/>
      <vxe-column field="location.no" title="business.label.location"/>
      <vxe-column field="logicalStore.name" title="business.label.logicalStore" width="90"/>
      <vxe-column field="detail.quantity" title="business.label.quantity"/>
      <vxe-column field="detail.inventoryState" title="business.label.inventoryStatus">
        <span slot-scope="{ row }">{{inventoryStates.find(item => item.ordinal === row.detail.inventoryState).name}}</span>
      </vxe-column>
      <vxe-column field="detail.reasons" title="business.label.reason"/>
    </vxe-table>
  </a-spin>
</template>
<script>
import { findAll, findEnum, findOne } from '@/api/Api'
import { CountingOrder } from '@/api/dto/order/CountingOrder'
import Vue from 'vue'
import { SCREEN_HEIGHT } from '@/store/mutation-types'

export default {
  name: 'CountingApproveDetail',
  data() {
    return {
      loading: false,
      order: new CountingOrder(),
      details: [],
      inventoryStates: [],
      scrollY: Vue.ls.get(SCREEN_HEIGHT) * (0.78)// 表格竖向滚动条,减去的数值是页面其他元素的高度
    }
  },
  props: {
    orderStatus: {
      type: Array,
      default: []
    },
    countingTypes: {
      type: Array,
      default: []
    }
  },
  mounted() {
    findEnum('InventoryState').then(res => {
      if (res.success) {
        this.inventoryStates = res.result
      }
    })
  },
  methods: {
    refresh(record) {
      if (record) {
        this.order.id = record.order.id
      }
      if (this.order.id === null || this.order.id === undefined) {
        return this.$message.warning('请先选择单据')
      }
      this.loading = true
      findOne('countingOrderFactory', { id: this.order.id }).then(res => {
        if (res.success) {
          this.order = res.result
          findAll('countingDetailFactory', { 'order.id': this.order.id }).then(res1 => {
            if (res1.success) {
              this.details = res1.result
            }
          })
        }
        setTimeout(() => {
          this.loading = false
        }, 200)
      }).finally(() => this.loading = false)
    },
    clear() {
      this.order = new CountingOrder()
      this.details = []
    }
  }
}
</script>
<style scoped>
.normalFont {
  font-weight: bold;
  color: #404040;
}
</style>